// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ReactVirtualGrid - ONLY for multi-view horizontal scrolling */
/* Main container that replaces the flex layout */
.JcMKK_02btI4lBum4Rtm {
  position: relative;
  width: 100%;
  overflow: hidden;
  /* Remove padding to allow scroll to screen edge */
  /* Ensure arrows are positioned relative to this container */
  /* Performance optimizations */
  contain: layout style paint;
  will-change: scroll-position;
  /* Jackpot panel adjustments */
}
.JcMKK_02btI4lBum4Rtm:hover {
  /* Provide hover detection area for arrows */
}
.JcMKK_02btI4lBum4Rtm[data-has-jackpot='true'] {
  min-width: 0;
  width: 100%;
}
/* Empty state container */
.eZhTJEmgwmDurJjONWWR {
  position: relative;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 200px;
}
/* Remove min-height for favorites section */
.eZhTJEmgwmDurJjONWWR[data-is-favorites='true'] {
  min-height: auto;
}
/* React-window List styling */
.DTuoYXG_rOz88na5e0NU {
  outline: none !important;
  /* Hide scrollbars to match original design */
  scrollbar-width: none;
  /* Smooth scrolling */
  scroll-behavior: smooth;
  -webkit-overflow-scrolling: touch;
  /* Prevent overscroll */
  overscroll-behavior-x: none;
  overscroll-behavior-y: auto;
  /* Prevent vertical scroll - only horizontal scroll in multi-view */
  overflow-y: hidden !important;
}
.DTuoYXG_rOz88na5e0NU::-webkit-scrollbar {
  display: none;
}
/* Individual game item wrapper */
.GcBIfvx9T_AFri_JtMl3 {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  padding-right: 8px;
  /* Default gap */
}
@media (pointer: coarse) {
  .DTuoYXG_rOz88na5e0NU {
    scroll-snap-type: x mandatory;
    scroll-padding-left: 8px;
  }
  .GcBIfvx9T_AFri_JtMl3 {
    scroll-snap-align: start;
  }
}
@media (pointer: coarse) and (orientation: landscape) and (min-width: 1025px) {
  .DTuoYXG_rOz88na5e0NU {
    scroll-padding-left: 20px;
  }
}
/* Remove gap from last card - gap handled by end padding */
.GcBIfvx9T_AFri_JtMl3.Hj5GR_0rNdUSj5z6Pjwk {
  padding-right: 0;
}
/* Desktop gap adjustment */
@media (min-width: 1025px) {
  .GcBIfvx9T_AFri_JtMl3 {
    padding-right: 10px;
  }
  .GcBIfvx9T_AFri_JtMl3.Hj5GR_0rNdUSj5z6Pjwk {
    padding-right: 0;
  }
}
/* Compact grids use an 8px gap at every viewport size, including after the last card. */
.JcMKK_02btI4lBum4Rtm[data-game-card-size='compact'] .GcBIfvx9T_AFri_JtMl3,
.JcMKK_02btI4lBum4Rtm[data-game-card-size='compact'] .GcBIfvx9T_AFri_JtMl3.Hj5GR_0rNdUSj5z6Pjwk {
  padding-right: 8px;
}
/* Restore vertical padding for jackpot panel sections on desktop */
/* Landscape orientation with jackpot panels */
@media (orientation: landscape) and (max-width: 1025px) {
  .JcMKK_02btI4lBum4Rtm[data-has-jackpot='true'] {
    padding: 40px 0;
  }
  .JcMKK_02btI4lBum4Rtm[data-section-name='HOT_GAMES'],
  .JcMKK_02btI4lBum4Rtm[data-section-name='COLD_GAMES'] {
    padding: 0 0 23px;
  }
}
/* Large screens with jackpot panels */
@media (min-width: 1026px) {
  .JcMKK_02btI4lBum4Rtm[data-has-jackpot='true'] {
    padding: 54px 0;
  }
  .JcMKK_02btI4lBum4Rtm[data-section-name='HOT_GAMES'],
  .JcMKK_02btI4lBum4Rtm[data-section-name='COLD_GAMES'] {
    padding: 0 0 28px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/shared/components/VirtualizedGrid/ReactVirtualGrid.module.css"],"names":[],"mappings":"AAAA,gEAAgE;AAChE,iDAAiD;AACjD;EACE,kBAAkB;EAClB,WAAW;EACX,gBAAgB;EAChB,kDAAkD;EAClD,4DAA4D;EAC5D,8BAA8B;EAC9B,2BAA2B;EAC3B,4BAA4B;EAC5B,8BAA8B;AAChC;AACA;EACE,4CAA4C;AAC9C;AACA;EACE,YAAY;EACZ,WAAW;AACb;AACA,0BAA0B;AAC1B;EACE,kBAAkB;EAClB,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,iBAAiB;AACnB;AACA,4CAA4C;AAC5C;EACE,gBAAgB;AAClB;AACA,8BAA8B;AAC9B;EACE,wBAAwB;EACxB,6CAA6C;EAC7C,qBAAqB;EACrB,qBAAqB;EACrB,uBAAuB;EACvB,iCAAiC;EACjC,uBAAuB;EACvB,2BAA2B;EAC3B,2BAA2B;EAC3B,mEAAmE;EACnE,6BAA6B;AAC/B;AACA;EACE,aAAa;AACf;AACA,iCAAiC;AACjC;EACE,aAAa;EACb,mBAAmB;EACnB,2BAA2B;EAC3B,kBAAkB;EAClB,gBAAgB;AAClB;AACA;EACE;IACE,6BAA6B;IAC7B,wBAAwB;EAC1B;EACA;IACE,wBAAwB;EAC1B;AACF;AACA;EACE;IACE,yBAAyB;EAC3B;AACF;AACA,2DAA2D;AAC3D;EACE,gBAAgB;AAClB;AACA,2BAA2B;AAC3B;EACE;IACE,mBAAmB;EACrB;EACA;IACE,gBAAgB;EAClB;AACF;AACA,wFAAwF;AACxF;;EAEE,kBAAkB;AACpB;AACA,mEAAmE;AACnE,8CAA8C;AAC9C;EACE;IACE,eAAe;EACjB;EACA;;IAEE,iBAAiB;EACnB;AACF;AACA,sCAAsC;AACtC;EACE;IACE,eAAe;EACjB;EACA;;IAEE,iBAAiB;EACnB;AACF","sourcesContent":["/* ReactVirtualGrid - ONLY for multi-view horizontal scrolling */\n/* Main container that replaces the flex layout */\n.virtualizedContainer {\n  position: relative;\n  width: 100%;\n  overflow: hidden;\n  /* Remove padding to allow scroll to screen edge */\n  /* Ensure arrows are positioned relative to this container */\n  /* Performance optimizations */\n  contain: layout style paint;\n  will-change: scroll-position;\n  /* Jackpot panel adjustments */\n}\n.virtualizedContainer:hover {\n  /* Provide hover detection area for arrows */\n}\n.virtualizedContainer[data-has-jackpot='true'] {\n  min-width: 0;\n  width: 100%;\n}\n/* Empty state container */\n.emptyContainer {\n  position: relative;\n  width: 100%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  min-height: 200px;\n}\n/* Remove min-height for favorites section */\n.emptyContainer[data-is-favorites='true'] {\n  min-height: auto;\n}\n/* React-window List styling */\n.virtualizedList {\n  outline: none !important;\n  /* Hide scrollbars to match original design */\n  scrollbar-width: none;\n  /* Smooth scrolling */\n  scroll-behavior: smooth;\n  -webkit-overflow-scrolling: touch;\n  /* Prevent overscroll */\n  overscroll-behavior-x: none;\n  overscroll-behavior-y: auto;\n  /* Prevent vertical scroll - only horizontal scroll in multi-view */\n  overflow-y: hidden !important;\n}\n.virtualizedList::-webkit-scrollbar {\n  display: none;\n}\n/* Individual game item wrapper */\n.gameItemWrapper {\n  display: flex;\n  align-items: center;\n  justify-content: flex-start;\n  padding-right: 8px;\n  /* Default gap */\n}\n@media (pointer: coarse) {\n  .virtualizedList {\n    scroll-snap-type: x mandatory;\n    scroll-padding-left: 8px;\n  }\n  .gameItemWrapper {\n    scroll-snap-align: start;\n  }\n}\n@media (pointer: coarse) and (orientation: landscape) and (min-width: 1025px) {\n  .virtualizedList {\n    scroll-padding-left: 20px;\n  }\n}\n/* Remove gap from last card - gap handled by end padding */\n.gameItemWrapper.lastItem {\n  padding-right: 0;\n}\n/* Desktop gap adjustment */\n@media (min-width: 1025px) {\n  .gameItemWrapper {\n    padding-right: 10px;\n  }\n  .gameItemWrapper.lastItem {\n    padding-right: 0;\n  }\n}\n/* Compact grids use an 8px gap at every viewport size, including after the last card. */\n.virtualizedContainer[data-game-card-size='compact'] .gameItemWrapper,\n.virtualizedContainer[data-game-card-size='compact'] .gameItemWrapper.lastItem {\n  padding-right: 8px;\n}\n/* Restore vertical padding for jackpot panel sections on desktop */\n/* Landscape orientation with jackpot panels */\n@media (orientation: landscape) and (max-width: 1025px) {\n  .virtualizedContainer[data-has-jackpot='true'] {\n    padding: 40px 0;\n  }\n  .virtualizedContainer[data-section-name='HOT_GAMES'],\n  .virtualizedContainer[data-section-name='COLD_GAMES'] {\n    padding: 0 0 23px;\n  }\n}\n/* Large screens with jackpot panels */\n@media (min-width: 1026px) {\n  .virtualizedContainer[data-has-jackpot='true'] {\n    padding: 54px 0;\n  }\n  .virtualizedContainer[data-section-name='HOT_GAMES'],\n  .virtualizedContainer[data-section-name='COLD_GAMES'] {\n    padding: 0 0 28px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"virtualizedContainer": `JcMKK_02btI4lBum4Rtm`,
	"emptyContainer": `eZhTJEmgwmDurJjONWWR`,
	"virtualizedList": `DTuoYXG_rOz88na5e0NU`,
	"gameItemWrapper": `GcBIfvx9T_AFri_JtMl3`,
	"lastItem": `Hj5GR_0rNdUSj5z6Pjwk`
};
export default ___CSS_LOADER_EXPORT___;
